module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/november/mainvisual-present_b7ed8440eddcc3a2345670711942cf01.png";